<template>
  <div>
    <h1>Мониторинг и коммуникация</h1>
    <button
      class="btn btn-success excel-download-btn"
    >
      <i
        class="fa fa-file-excel-o"
      />
      Выгрузить в Excel
    </button>
    <c-box>
      <table
        class="table"
      >
        <thead>
          <tr>
            <th>Дата</th>
            <th>Заголовок.</th>
            <th>Текст</th>
            <th>Источник</th>
            <th>URL</th>
            <th>Тип источника</th>
            <th>Тип сообщения</th>
            <th>Тональность</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row of monitoringData"
            :key="row.date"
          >
            <td v-text="row.date" />
            <td v-text="row.header" />
            <td v-text="row.text" />
            <td v-text="row.source" />
            <td v-text="row.url" />
            <td v-text="row.source_type" />
            <td v-text="row.msg_type" />
            <td v-text="row.tonality" />
          </tr>
        </tbody>
      </table>
    </c-box>
  </div>
</template>

<script>
import CBox from '../../../../../../resources/js/components/ui/CBox'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Monitoring',
  components: { CBox },

  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapState({
      monitoringData: state => state.serm.monitoring.data
    })
  },
  mounted () {
    this.fetchMonitoring()
  },
  methods: {
    ...mapActions({
      fetchMonitoring: 'monitoring/fetch'
    })
  }
}
</script>
